import { render, staticRenderFns } from "./EditSoundGroupPopup.vue?vue&type=template&id=7379b5b5&scoped=true"
import script from "./EditSoundGroupPopup.vue?vue&type=script&lang=ts"
export * from "./EditSoundGroupPopup.vue?vue&type=script&lang=ts"
import style0 from "./EditSoundGroupPopup.vue?vue&type=style&index=0&id=7379b5b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7379b5b5",
  null
  
)

export default component.exports